import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';

export const eldAvailabilityStatusSchema = z.object({
  data: z.object({
    status: z.boolean(),
    syncIntervalInMinutes: z.number(),
    lastSyncCompleteTimeStamp: coercedDate,
  }),
  message: z.string(),
});

export type EldAvailabilityStatus = z.infer<typeof eldAvailabilityStatusSchema>;
